import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { CopyDesignDocument } from './copy.generated';

export const useCopyDesign = (options: ApiOptions<typeof CopyDesignDocument> = {}) => {
  const { t } = useTranslation();
  return useMutation(CopyDesignDocument, {
    ...useNotifications(CopyDesignDocument, {
      failure: t('api.common.error_generic'),
      success: (data) => t('api.designs.copy_success', { name: data.copyDesign?.design.name }),
    }),

    ...options,
  });
};
